/* global Swiper, Waypoint, dataLayer, wocluAJAXURL */
;(function($) {
  "use strict";

  var navigationPrimarySticky;

  var navigationPrimary = {
    initialize: function() {
      navigationPrimarySticky = new Waypoint.Sticky({
        element: $(".site-header__navigation-primary")[0],
        stuckClass: "site__header__navigation__primary--fixed"
      });
    },
    destroy: function() {
      if (typeof navigationPrimarySticky.options !== "undefined") {
        navigationPrimarySticky.destroy();
      }
    },
    reinit: function() {
      if ( navigationPrimarySticky === undefined ) {
        return;
      }
      if (typeof navigationPrimarySticky.options !== "undefined") {
        navigationPrimarySticky.destroy();
      }
      navigationPrimary.initialize();
    }
  };

  const extended_banner_animation_js = document.getElementById('extended_banner_animation_js')
  if (extended_banner_animation_js) {
      // Adjust menu sticky position when animated banner opens and closes.
      const resizeObserver = new ResizeObserver(entries => {
          navigationPrimary.reinit()
      })
      resizeObserver.observe(extended_banner_animation_js)
  }

 (function initialize() {
    var $Body = $('body');
    if ( $Body.hasClass("page-template-page-shift") || document.getElementsByClassName('site-header__navigation-primary').length == 0 ) {
      // Don't have current menu style
    } else {
      navigationPrimary.initialize();
    }
    // Start - Page: Archive, Tag, Author.
    if ($Body.hasClass("archive") || $Body.hasClass("category") || $Body.hasClass("tag") || $Body.hasClass("author")) {
      $(document).on("click", ".post__filter__sort ul li", function() {
        var $post__filer__sorted = $(".post__filter__sorted");
        $(".post__filter__sort").removeClass("post__filter__sort--visible");
        $post__filer__sorted.find(".glyph").removeClass("glyph-keyboard_arrow_up").addClass("glyph-keyboard_arrow_down");
        $post__filer__sorted.fund('span:first-child').text($(this).text());
      });

      $(document).on("click", ".post__filter__sorted", function() {
        var $post__filer__sort = $(".post__filter__sort"), $post__filer__sorted = $(".post__filter__sorted");
        if ($post__filer__sort.hasClass("post__filter__sort--visible")) {
            $post__filer__sort.removeClass("post__filter__sort--visible");
            $post__filer__sorted.find(".glyph").removeClass("glyph-keyboard_arrow_up").addClass("glyph-keyboard_arrow_down");
        } else {
            $post__filer__sort.addClass("post__filter__sort--visible");
            $post__filer__sorted.find(".glyph").removeClass("glyph-keyboard_arrow_down").addClass("glyph-keyboard_arrow_up");
        }
        return false;
      });

      $(document).on("focusout", ".post__filter__sort--visible", function() {
        setTimeout(function() {
          $(".post__filter__sort").removeClass("post__filter__sort--visible");
          $(".post__filter__sorted").find(".glyph").removeClass("glyph-keyboard_arrow_up").addClass("glyph-keyboard_arrow_down");
        }, 100);
      });
    }

    $(document).ready(function() {
      scrollToFacet();

      $(document).on('click', function(event) {
        var $eventTarget = $(event.target);
        if (!$eventTarget.is(".fs-label, .fs-dropdown, .fs-option, .header-label, .facet-close-btn, .fs-checkbox, .fs-option-label")) {
          toggleBodyScroll();
        }

        if ($eventTarget.is(".ondemand-paging .facetwp-page")) {
          $('html, body').animate({
            scrollTop: $('.facetwp-template').offset().top - 357
          }, 50);
        }

        if ($eventTarget.is(".integration-paging .facetwp-page")) {
          $('html, body').animate({
            scrollTop: $('.facetwp-template').offset().top - 456
          }, 50);
        }
      });
    });

    $(window).on('resize', function() {
      if ( !$Body.hasClass("page-template-page-shift") || document.getElementsByClassName('site-header__navigation-primary').length ) {
        navigationPrimary.reinit();
      }

      if ($(window).width() >= 768) {
        $('body').removeClass('disable-scroll');
      }
    });


    $(document).on('facetwp-loaded', function() {


      setMultipleSelectedFselect();
      ctFacetsCloseButton();

      $('.facetwp-facet').each(function() {

        var $This = $(this), dataName = $This.attr('data-name'), fsOptions = $This.find('.fs-option'), fsWrap = $This.find('.fs-wrap'), fsArrow = $This.find('.fs-wrap .fs-label-wrap .fs-arrow'), fsDefaultClass = 'fs-default', fsRadios = $This.find('.facetwp-radio');

        /* FacetWP's ARIA implementation is quite broken. */
        for (var op=0, fsLen=fsOptions.length; op<fsLen; op++) {
          var option = fsOptions.eq(op);
          // Need a heartbeat for the class attribute to finish updating
          option.on('click', function(){
            var $t = $(this);
            setTimeout(function(){
              $t.attr('aria-checked', $t.hasClass('selected').toString() );
              if (typeof sega4 == 'object' && typeof sega4.facet.logSelection == 'function'){
                sega4.facet.logSelection($t, dataName);
              }
            }, 300);
          });
        }

        if (fsRadios.length) {
          for (var fra=0, fraLen=fsRadios.length; fra<fraLen; fra++) {
            var fRadioItem = fsRadios.eq(fra);
            fRadioItem.on('click', function(){
              if (typeof sega4 == 'object' && typeof sega4.facet.logSelection == 'function'){
                sega4.facet.logSelection($(this), dataName);
              }
            })
          }
        }

        if (dataName == 'prod_innovations_types') {
          if (FWP.facets.prod_innovations_types.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('prod-innovations-types-clear-btn');
          }
        }
        else if (dataName == 'prod_innovations_tags') {
          if (FWP.facets.prod_innovations_tags.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('prod-innovations-types-clear-btn');
          }
        }
        else if (dataName == 'prod_innovations_years') {
          if (FWP.facets.prod_innovations_years.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('prod-innovations-years-clear-btn');
          }
        }
        else if (dataName == 'resources_topic') {
          if (FWP.facets.resources_topic.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('resources-topic-clear-btn');
          }
        }
        else if (dataName == 'resources_industry') {
          if (FWP.facets.resources_industry.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('resources-industry-clear-btn');
          }
        }
        else if (dataName == 'resources_type') {
          if (FWP.facets.resources_type.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('resources-type-clear-btn');
          }
        }
        else if (dataName == 'integrations_categories') {
          if (FWP.facets.integrations_categories.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('integrations_categories-clear-btn');
          }
        }
        else if (dataName == 'popular_integrations') {
          if (FWP.facets.popular_integrations.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('popular_integrations-clear-btn');
          }
        }
        else if (dataName == 'partner_type') {
          if (FWP.facets.partner_type.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('partner_type-clear-btn');
          }
        }
        else if (dataName == 'partner_region') {
          if (FWP.facets.partner_region.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('partner_region-clear-btn');
          }
        }
        else if (dataName == 'explainers_topics') {
          if (FWP.facets.explainers_topics.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('explainers-topics-clear-btn');
          }
        }
        else if (dataName == 'ct_industry') {
          if (FWP.facets.ct_industry.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('industry-clear-btn');
          }
        }
        else if (dataName == 'ct_size') {
          if (FWP.facets.ct_size.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('size-clear-btn');
          }
        }
        else if (dataName == 'ct_solution') {
          if (FWP.facets.ct_solution.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('solution-clear-btn');
          }
        }
        else if (dataName == 'ct_product') {
          if (FWP.facets.ct_product.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('product-clear-btn');
          }
        }
        else if (dataName == 'ct_outcome') {
          if (FWP.facets.ct_outcome.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('outcome-clear-btn');
          }
        }
        else if (dataName == 'ondemand_topic') {
          if (FWP.facets.ondemand_topic.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('topic-clear-btn');
          }
        }
        else if (dataName == 'ondemand_track') {
          if (FWP.facets.ondemand_track.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('track-clear-btn');
          }
        }
        else if (dataName == 'ondemand_type') {
          if (FWP.facets.ondemand_type.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('type-clear-btn');
          }
        }
        else if (dataName == 'ondemand_industry') {
          if (FWP.facets.ondemand_industry.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('od-industry-clear-btn');
          }
        }
        else if (dataName == 'ondemand_year') {
          if (FWP.facets.ondemand_year.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('year-clear-btn');
          }
        }
        else if (dataName == 'ondemand_speaker') {
          if (FWP.facets.ondemand_speaker.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('speaker-clear-btn');
          }
          // Move A Most Beautiful Thing to bottom
          var amostbeautifulthing = $This.find('.fs-dropdown .fs-options .fs-option[data-value="a-most-beautiful-thing"]');
          if (amostbeautifulthing.length) {
            $This.find('.fs-dropdown .fs-options').append(amostbeautifulthing);
          }
        }
        else if (dataName == 'ondemand_company') {
          if (FWP.facets.ondemand_company.length == 0) {
            fsWrap.addClass(fsDefaultClass);
          } else {
            fsArrow.addClass('company-clear-btn');
          }
          // Move A Most Beautiful Thing to bottom
          var amostbeautifulthing = $This.find('.fs-dropdown .fs-options .fs-option[data-value="a-most-beautiful-thing"]');
          if (amostbeautifulthing.length) {
            $This.find('.fs-dropdown .fs-options').append(amostbeautifulthing);
          }
        }

        if (dataName == 'ondemand_company' ||
            dataName == 'ondemand_speaker' ||
            dataName == 'ct_industry' ||
            dataName == 'ct_outcome' ||
            dataName == 'integrations_categories' ||
            dataName == 'popular_integrations' ||
            dataName == 'partner_type' ||
            dataName == 'partner_region' ||
            dataName == 'prod_innovations_types' ||
            dataName == 'prod_innovations_tags' ||
            dataName == 'prod_innovations_years'  ) {
          if ($This.hasClass('after-clear')) {
            var $fmultiselect = $This;
            $fmultiselect.find('.fs-wrap .fs-dropdown').addClass('hide');
            setTimeout(function() {
              $fmultiselect.find('.fs-wrap').removeClass('fs-open');
              $fmultiselect.removeClass('after-clear');
              $fmultiselect.find('.fs-wrap .fs-dropdown').addClass('fs-hidden').removeClass('hide');
            }, 100);
          }
        }
      });


      $('.prod-innovations-types-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'prod_innovations_types';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.prod-innovations-tags-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'prod_innovations_tags';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.prod-innovations-years-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'prod_innovations_years';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });

      $('.resources-topic-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'resources_topic';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });


      $('.integrations_categories-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'integrations_categories';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });

      $('.popular_integrations-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'popular_integrations';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });

      $('.partner_type-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'partner_type';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });

      $('.partner_region-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'partner_region';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });


      $('.resources-industry-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'resources_industry';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });

      $('.resources-type-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'resources_type';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });



      $('.explainers-topics-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'explainers_topics';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });


      $('.industry-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ct_industry';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.size-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ct_size';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.solution-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ct_solution';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.product-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ct_product';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.outcome-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ct_outcome';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.topic-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ondemand_topic';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.track-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ondemand_track';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.type-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ondemand_type';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.od-industry-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ondemand_industry';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.year-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ondemand_year';
        $This.css('transform', 'rotate(0deg)');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.speaker-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ondemand_speaker';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });
      $('.company-clear-btn').on('click', function() {
        var $This = $(this), elemString = 'ondemand_company';
        $This.css('transform', 'rotate(0deg)');
        $('.facetwp-facet-'+ elemString).addClass('after-clear');
        FWP.reset(elemString);
        logFacetReset(elemString);
        $This.parent().next().addClass('hide');
      });

      setTimeout(function() {
        facetReloadAsRadioButton();
      }, 100);

    });

    $(document).on('facetwp-refresh', function() {
      setMultipleSelectedFselect();
      toggleBodyScroll();
    });

    function scrollToFacet() {
      if ($(window).width() < 768) {
        $('.facetwp-type-fselect').on('click', function() {
          var $This = $(this);
          var offset = $This.offset();
          var left = 16 - offset.left;
          var top = Math.round($This.get(0).getBoundingClientRect().top);
          $This.find('.fs-dropdown').css('top', top + 49);
          setTimeout(function() {
            toggleBodyScroll();
          }, 100);
        });
      }
    }

    function facetReloadAsRadioButton() {
      if ($(window).width() < 768) {
        $('.facetwp-facet').each(function() {
          var $This = $(this), dataName = $This.attr('data-name');
          if (
            dataName == 'integrations_categories' ||
            dataName == 'popular_integrations' ||
            dataName == 'partner_type' ||
            dataName == 'partner_region' ||
            dataName == 'resources_topic' ||
            dataName == 'resources_industry' ||
            dataName == 'resources_type' ||
            dataName == 'explainers_topics' ||
            dataName == 'ct_industry' ||
            dataName == 'ct_size' ||
            dataName == 'ct_solution' ||
            dataName == 'ct_product' ||
            dataName == 'ct_outcome' ||
            dataName == 'ondemand_type' ||
            dataName == 'ondemand_topic' ||
            dataName == 'ondemand_track' ||
            dataName == 'ondemand_company' ||
            dataName == 'ondemand_speaker' ||
            dataName == 'ondemand_industry' ||
            dataName == 'ondemand_year' ) {
            $This.find('.fs-wrap').removeClass('fs-open');
            $This.find('.fs-dropdown').addClass('fs-hidden');
            $('body').removeClass('disable-scroll');
          }
        });
      }
    }

    function toggleBodyScroll() {
      if ($(window).width() < 768) {
        var open = false;
        var findFslectOpen = $('.facetwp-facet').each(function() {
          if ($(this).find('.fs-wrap').hasClass('fs-open')) {
            open = true;
          }
        });
        $.when(findFslectOpen).done(function() {
          if (open == true) {
            //$('body').addClass('disable-scroll');
          } else {
            $('body').removeClass('disable-scroll');
          }
        });
      }
    }

    function setMultipleSelectedFselect() {
      $('.facetwp-facet').each(function() {
          var $This = $(this),
              dataName = $This.attr('data-name');
        if (dataName == 'ct_industry' || dataName == 'ondemand_company' || dataName == 'ondemand_speaker') {
          var text = '';
          $This.find('.fs-dropdown .fs-options .fs-option').each(function() {
            if ($(this).hasClass('selected')) {
              if ($(this).text().length < text.length || text === '') {
                text = $(this).text();
              }
            }
          });
          var fsLabel = $This.find('.fs-label-wrap .fs-label'),
              total = parseInt(fsLabel.text());
          if (typeof total === 'number') {
            var more = total - 1;
            if (more > 0) {
              fsLabel.text(text + ' +' + more);
            }
          }
        }
      });
    }

    function ctFacetsCloseButton() {
      $('.facetwp-facet').each(function() {
        var $This = $(this), dataName = $This.attr('data-name'), optionsMenu = $This.find('.fs-dropdown .fs-options'), labelString = '';

        if (!optionsMenu.length || dataName == '') {
          // missing required stuff - continute to next jQuery element:
          return true;
        }
        // $This.find('.fs-dropdown .fs-options .header-label').remove();
        // $This.find('.fs-dropdown .fs-options .fs-option[data-idx="0"]').remove();

        optionsMenu.find('.header-label').remove();
        optionsMenu.find('.fs-option[data-idx="0"]').remove();

        switch (dataName) {
          case 'blog':
              labelString = window.seismic_global_variables.translations.categories;
              break;
          case 'prod_innovations_types':
              labelString = window.seismic_global_variables.translations.prod_innovations_types;
              break;
          case 'prod_innovations_tags':
              labelString = window.seismic_global_variables.translations.prod_innovations_tags;
              break;
          case 'prod_innovations_years':
              labelString = window.seismic_global_variables.translations.prod_innovations_years;
              break;
          case 'integrations_categories':
              labelString = window.seismic_global_variables.translations.integrations;
              break;
          case 'popular_integrations':
              labelString = window.seismic_global_variables.translations.popular_integrations;
              break;
          case 'partner_type':
              labelString = window.seismic_global_variables.translations.partner_types;
              break;
          case 'partner_region':
              labelString = window.seismic_global_variables.translations.partner_regions;
              break;
          case 'resources_topic':
              labelString = window.seismic_global_variables.translations.topics;
              break;
          case 'resources_industry':
              labelString = window.seismic_global_variables.translations.industries;
              break;
          case 'resources_type':
              labelString = window.seismic_global_variables.translations.types;
              break;
          case 'explainers_topics':
              labelString = window.seismic_global_variables.translations.topics;
              break;
          case 'ct_industry':
              labelString = window.seismic_global_variables.translations.industry;
              break;
          case 'ct_size':
              labelString = window.seismic_global_variables.translations.size;
              break;
          case 'ct_solution':
              labelString = window.seismic_global_variables.translations.solution;
              break;
          case 'ct_product':
              labelString = window.seismic_global_variables.translations.product;
              break;
          case 'ct_outcome':
              labelString = window.seismic_global_variables.translations.outcome;
              break;
          case 'ondemand_topic':
              labelString = window.seismic_global_variables.translations.topic;
              break;
          case 'ondemand_track':
              labelString = window.seismic_global_variables.translations.track;
              break;
          case 'ondemand_type':
              labelString = window.seismic_global_variables.translations.speaker;
              break;
          case 'ondemand_industry':
              labelString = window.seismic_global_variables.translations.industry;
              break;
          case 'ondemand_year':
              labelString = window.seismic_global_variables.translations.year;
              break;
          case 'ondemand_speaker':
              labelString = window.seismic_global_variables.translations.speaker_names;
              break;
          case 'ondemand_company':
              labelString = window.seismic_global_variables.translations.companies;
              break;
          default:
              // do nothing;
        }

        if (labelString != '') {
          optionsMenu.prepend('<div class="header-label">' + labelString + '<span class="facet-close-btn"></div>');
        }

      });

      $('.facet-close-btn').on('click', function() {
        var $This = $(this), uppermostParent = $This.parent().parent().parent().parent();
        $This.parent().parent().parent().addClass('fs-hidden');
        $This.css('transform', 'rotate(0deg)');
        uppermostParent.removeClass('fs-open');
        uppermostParent.attr('aria-expanded', 'false');
        //$This.parent().parent().parent().parent().click();
      });
    }

    /* BACK TO TOP: visibility handler. Now encapsulated. */
    function backToTopVisibility() {
      var BTP = $('#back-to-top');
      if (!BTP.length) { return; }
      $(window).on('scroll', function() {
        var height = $(window).scrollTop();
        if (height > 1500) {
          BTP.fadeIn();
        } else {
          BTP.fadeOut();
        }
      });
    }
    $(document).ready(function() {
      backToTopVisibility();
    });


  })();

  $(document).ready(function() {
    $('.icon-search').attr('data-toggle', 'tooltip').attr('data-placement', 'bottom').attr('data-original-title', 'Search');
  });

  // Click: Tagging.
  //  @revision   2022-11-17 @spencers  Add sega4 checks to prevent duplicate data/GA logging.
  $(document).on("click", "a", function() {
    var eventName = null, doIt = true, sega4Check = (typeof sega4 != 'undefined' && typeof sega4.getInitStatus == 'function');

    if ($(this).closest(".site-header").length > 0) {
      eventName = "header";
      if (sega4Check) { doIt = sega4.getInitStatus('header'); }
    } else if ($(this).closest(".site-footer").length > 0) {
      eventName = "footer";
      if (sega4Check) { doIt = sega4.getInitStatus('footer'); }
    } else {
      eventName = "body";
      if (sega4Check) {
          // doIt = !sega4.getInitStatus('blog_page') && !sega4.getInitStatus('enablement_explainers_page')
          
          // Blocking for additional elements from body_click events.
          if (sega4.getInitStatus('blog_page')) {
              doIt = false // don't trigger on blog
          } else if (sega4.getInitStatus('enablement_explainers_page')) {
              doIt = false // don't trigger on enablement explainers
          } else if (sega4.getInitStatus('financial_services_page') && this.closest('.values-block-event-track')) {
              // See initFinancialServicesPage() in sega4.js
              doIt = false // don't trigger on financial services where anchor is values block.
          } else {
              doIt = true
          }
      }
    }

    if (typeof dataLayer !== 'undefined' && doIt == true) {
      sega4.console('Click: Tagging - seismic.js')
      sega4.log({
          text: $(this).text().trim(),
          event: eventName + '_click',
      })

    //   dataLayer.push({
    //     "text": $(this).text().trim(),
    //     "event": eventName + "_click"
    //   });
    }

    return true;
  });

  // Click: Tagging.
  $(document).on("click", ".hs-button", function() {
    if ((window.location.pathname.indexOf("request-demo") > -1) && jQuery(".hs-error-msgs").length === 0) {
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          "event": "demo_requested",
          "demorequest_jobtitle": $("input[name=jobtitle]").val(),
          "demorequest_company": $("input[name=company]").val(),
          "demorequest_industry": $("select[name=industry] option:selected").text()
        });
      }
    }
    return true;
  });


   $(document).ready(function() {
    var settings = {
      autoplay: true,
      autoplaySpeed: 0,
      slidesToShow: 6,
      slidesToScroll: 1,
      variableWidth: true,
      speed: 8000,
      infinite: true,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      pauseOnFocus: false,
      pauseOnHover: false
    };
    $('.partners-list').slick(settings);
    $('.partners-list-2').slick(settings);
  });

  const btnToggleMode = document.querySelector(".btn-toggle-mode");


  var currentTheme = localStorage.getItem("theme");
  $('.btn-toggle-mode').attr('data-toggle', 'tooltip').attr('data-placement', 'bottom');

  if (currentTheme == 'dark') {
    document.body.classList.remove("light-mode");
    document.body.classList.add("dark-mode");
    $('.btn-toggle-mode').attr('data-original-title', 'Light Mode');
  } else {
    document.body.classList.add("light-mode");
    document.body.classList.remove("dark-mode");
    $('.btn-toggle-mode').attr('data-original-title', 'Dark Mode');
  }


  $(".btn-toggle-mode").on('click', function() {
    var currentTheme = localStorage.getItem("theme");
    if (currentTheme == 'dark') {
      document.body.classList.add("light-mode");
      document.body.classList.remove("dark-mode");
      $('.btn-toggle-mode').attr('data-original-title', 'Dark Mode');
      currentTheme = document.body.classList.contains("light-mode") ? "light" : "dark";
    } else {
      document.body.classList.remove("light-mode");
      document.body.classList.add("dark-mode");
      $('.btn-toggle-mode').attr('data-original-title', 'Light Mode');
      currentTheme = document.body.classList.contains("dark-mode") ? "dark" : "light";
    }
    // console.log(currentTheme);
    localStorage.setItem("theme", currentTheme);
  });


  $(document).ready(function() {
    var winHeight = $(window).height(),
      docHeight = $(document).height();
    var max = docHeight - winHeight;
    // $("progress").attr('max', max);
    var value = $(window).scrollTop();
    // $("progress").attr('value', value);
    setShiftCustomScript();
    setProductHeroVideoHeight();
  });

  $(window).smartresize(function(){
    setShiftCustomScript();
    setProductHeroVideoHeight();
  });

  // function showTooltip() {
  //   if ($(window).width() > 960) {
  //     $('[data-toggle="tooltip"]').tooltip();
  //   }
  // }

  function setProductHeroVideoHeight() {
    $('.video-container').each(function() {
      $(this).height($(this).width());
    });
  }

  $(document).on('scroll', function() {
    var value = $(window).scrollTop();
    // $("progress").attr('value', value);
  });

  function addCTSingleHeaderBackground() {
    if ($('body').hasClass('single-customer-stories')) {
      var color = $('.ct-background-overlay').css("background-color");
      $('.site-header').css('background-color', color);
      $('.site__header__navigation__primary').css('background-color', color);

      // Set height for background
      var backgroundHeight = $('.hero-image').offset().top + $('.hero-image').width() - 64; // Square better get width
      if ($(window).width() < 1025) {
        backgroundHeight = 766;
      }
      if ($(window).width() < 768) {
        backgroundHeight = $('.hero-image').offset().top + ($('.hero-image').height() * 0.4);
      }
      $('.ct-background-overlay').css('height', backgroundHeight + 'px');
    }
  }

  // function setFSBatchHeaderBackgroundSize() {
  //   if ($('body').hasClass('gutenberg')) {
  //     if ($('.fs-batch-header').offset()) {
  //       var fsBatchSeismicVimeoTop;
  //       var fsBatchSeismicVimeoHeight;
  //       if ($('.seismic-vimeo').offset()) {
  //         fsBatchSeismicVimeoTop = $('.seismic-vimeo').offset().top;
  //         fsBatchSeismicVimeoHeight = $('.seismic-vimeo').height();
  //       } else {
  //         fsBatchSeismicVimeoTop = $('.photo-header').offset().top;
  //         fsBatchSeismicVimeoHeight = $('.photo-header').height();
  //       }
  //       var heightOfBg = fsBatchSeismicVimeoTop + (fsBatchSeismicVimeoHeight * 0.6);
  //       if ($(window).width() > 767) {
  //         $('.gutenberg-header-overlay').css("height", heightOfBg).show();
  //       } else {
  //         $('.gutenberg-header-overlay').css("height", fsBatchSeismicVimeoTop).show();
  //       }
  //     }
  //   }
  // }

  function setShiftCustomScript() {
    if ($('body').hasClass('page-template-page-shift')) {
      if ($(window).width() > 767) {
        var heightOnText = $('.save-the-date-text').height();
        $('.save-the-date-group .image-5').css('top', heightOnText + 48);
        setTimeout(function() {
          var $imageTop = $('.first-section .columns-container .wp-block-column:last-child');
          var top = $imageTop.offset().top;
          var imageBottom = top + $imageTop.width();
          var bottom = imageBottom + 96;
          $('.site__content .background-on-top').css('height', bottom);
          $('.site__content .background-on-top').css('max-height', bottom);
          $('.site__content .background-on-top').css('min-height', bottom);
          $('.site__content .background-on-top').css('top', 0);
          var conntainerBottom = $('.first-section .columns-container').height() + $('.first-section .columns-container').offset().top;
          if (conntainerBottom > imageBottom) {
            $('.what-on-top').css('margin-top', 264 + (imageBottom - conntainerBottom));
          }
        }, 200);
      } else {
        setTimeout(function() {
          var $imageTop = $('.first-section .columns-container .wp-block-column:last-child');
          var top = $imageTop.offset().top;
          var bottom = top + ($imageTop.width() / 2) + 48;
          $('.site__content .background-on-top').css('height', $imageTop.height() / 2);
          $('.site__content .background-on-top').css('top', bottom);
          $('.site__content .background-on-top').css('min-height', $imageTop.height() / 2);
          $('.site__content .background-on-top').css('max-height', $imageTop.height() / 2);
          $('.what-on-top').css('margin-top', 144);
        }, 200);
      }

    }
  }

  $(document).ready(function() {
    var $nav_slider = $('.video-slider');
    var $text_slider = $('.text-slider');
    $nav_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      slick.$slides.removeClass('slick-prev').removeClass('slick-next');
      $('.progress-bar').css('width', ((nextSlide + 1) / slick.$slides.length * 100) + '%');
      $('.current-slide').html(nextSlide + 1);
    });

    $nav_slider.on('afterChange init', function(event, slick, currentSlide) {
      // Set video play
      slick.$slides.each(function() {
        var $vimeo = $(this).find('.vimeo');
        var player = new Vimeo.Player($vimeo);

        player.pause();
        if ($(this).hasClass('slick-current')) {
          player.play();
        }
      });

      // Set class
      slick.$slides.removeClass('slick-prev').removeClass('slick-next');
      for (var i = 0; i < slick.$slides.length; i++) {
        var $slide = $(slick.$slides[i]);
        if ($slide.hasClass('slick-current')) {
          $slide.prev().addClass('slick-prev');
          $slide.next().addClass('slick-next');
          break;
        }
      }
    });

    $text_slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.video-slider',
      arrows: false,
      dots: false,
    });

    $nav_slider.slick({
      infinite: true,
      slideToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: true,
      arrows: true,
      dots: false,
      asNavFor: '.text-slider',
      focusOnSelect: true,
      responsive: [{
        breakpoint: 767,
        settings: {
          arrows: false
        }
      }, ]
    });

    /* deprecated: */
    $('.dei-video-container .video-inner').each(function() {
      $(this).modalVideo({
        channel: 'vimeo',
        vimeo: {
          autoplay: true
        }
      });
    });

    $('article.popup-video, .seismic-vimeo.popup-video').each(function() {
      if ($(this).attr('data-video-id') != '') {
        $(this).modalVideo({
          channel: 'vimeo',
          vimeo: {
            autoplay: true
          }
        });

        $(this).find('a').each(function() {
          $(this).on('click', function(event) {
            event.preventDefault();
          });
        });

      } else {
        var $vimeo = $(this).find('.vimeo');
        var player = new Vimeo.Player($vimeo);
        if (typeof sega4 == 'object' && sega4.hasOwnProperty('video') ) {
            sega4.video.init(iframe, player, false);
        }

        $(this).on('click', function() {
          $(this).parent().addClass('played');
          return player.play();
        });

        var $container = $(this).parent();
        $container.find('a').each(function() {
          $(this).on('click', function(event) {
            $container.addClass('played');
            return player.play();
          });
        });
      }
    });

    $(".vimeo-popup .wp-block-button__link").each(function() {
      $(this).attr('data-video-id', $(this).attr('rel'));
      if ($(this).attr('rel')) {
        $(this).modalVideo({
          channel: 'vimeo',
          vimeo: {
            autoplay: true
          }
        });
      }
    });

    if (typeof sega4 == 'object' && sega4.hasOwnProperty('video') && typeof sega4.video.initStrays == 'function' ) {
      sega4.video.initStrays();
    }

    function setProductFeaturesSpacing() {
      $('.product-feature').each(function() {
        var imgHeight = $(this).find('.product-images .image-list-inner').height();
        var textHeight = $(this).find('.text-col-inner').height();

        // Ensure always get image height
        if (imgHeight < 55) {
          imgHeight = $(this).find('.product-images .image-list-inner .group-images').height();
        }

        if ($(window).width() > 1025) {
          if (imgHeight > textHeight) {
            $(this).find('.text-col').height(imgHeight - 55);
          }
        } else {
          $(this).find('.text-col').removeAttr('style');
          $(this).find('.product-images').height(imgHeight - 55);
          if ($(window).width() < 768) {
            var rato = $(window).width() / 320;
            var shadowHeight = rato * 28;
            if (imgHeight > 0) {
              $(this).find('.product-images').height(imgHeight - shadowHeight);
            }
          }
        }
      });
      $(' .two-col-feature-block').each(function() {
        var imgHeight = $(this).find('.product-images .image-list-inner').height();
        var textHeight = $(this).find('.text-col-inner').height();

        // Ensure always get image height
        if (imgHeight < 55) {
          imgHeight = $(this).find('.product-images .image-list-inner .group-images').height();
        }

        if (imgHeight > 0) { $(this).find('.product-images').height(imgHeight - 55); }
        if ($(window).width() < 768) {
          var rato = $(window).width() / 320;
          var shadowHeight = rato * 28;
          if (imgHeight > 0) {
            $(this).find('.product-images').height(imgHeight - shadowHeight);
          }
        }
      });
    }

    $(window).on('scroll', function() {
      setProductFeaturesSpacing();
    });

    $(window).on('resize', function() {
      setProductFeaturesSpacing();
    });


  });

  /**
   * Use Google's reCAPTCHA to protect against spam and other types of automated abuse.
   * @param {Object} mktoForm
   * @param {Object} options
   * @param {String} options.size 'invisible', 'compact', 'normal'
   * @param {String} options.siteKey Public reCAPTCHA sitekey
   * @param {String} options.fieldName Marketo SOAP name for field that holds response value
   * @param {String} options.errorMessage Error message depending on choosen `size`
   * @return {Void}
   */
  function useReCAPTCHA(mktoForm) {

    if (typeof mktoForm == 'undefined') {
      console.log('Object mktoform not found. Exiting useReCAPTCHA');
      return;
    }
    if (typeof grecaptcha == 'undefined') {
      console.log('Object grecaptcha not found. Exiting useReCAPTCHA');
      return;
    }

    var formEl = mktoForm.getFormElem()[0]
    if (formEl.querySelector('#captcha')) {
        // #captcha doesnt existing unless it's been turned on in Marketo.
        console.log('Captcha Element already exists on form.')
        return
    }

    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (
      !Object.prototype.hasOwnProperty.call(options, "fieldName") ||
      !Object.prototype.hasOwnProperty.call(options, "sitekey") ||
      !Object.prototype.hasOwnProperty.call(options, "errorMessage") ||
      !Object.prototype.hasOwnProperty.call(options, "size")
    ) {
      if (console) {
        console.warn("Parameters for reCAPTCHA are missing.");
      }
      return;
    }

    var formId = mktoForm.getId();
    var reCAPTCHAEl = document.createElement("div");
    var reCAPTCHAResponse = "";

    reCAPTCHAEl.setAttribute("id", "reCAPTCHA_" + formId);
    formEl.appendChild(reCAPTCHAEl);

    var reCAPTCHA = grecaptcha.render("reCAPTCHA_" + formId, {
      size: options.size,
      sitekey: options.sitekey,
      callback: function callback(token) {
        mktoForm.submittable(true);
        // mktoForm.submit();
        if (token) {
          var hiddenFields = {};
          hiddenFields[options.fieldName] = token;
          mktoForm.addHiddenFields(hiddenFields);
          //mktoForm.submit();
        }
      },
      "error-callback": function errorCallback() {
        mktoForm.showErrorMessage(options.errorMessage);
      }
    });
    grecaptcha.execute(reCAPTCHA);

    mktoForm.onValidate(function(isValid) {
      if (!isValid || !mktoForm.submittable()) {
        return;
      }

      reCAPTCHAResponse = grecaptcha.getResponse(reCAPTCHA);

      if (!reCAPTCHAResponse) {
        if (options.size === 'invisible') {
          grecaptcha.execute(reCAPTCHA);
        } else {
          mktoForm.showErrorMessage(options.errorMessage);
        }
        mktoForm.submittable(false);
      } else {
        var hiddenFields = {};
        hiddenFields[options.fieldName] = reCAPTCHAResponse;
        mktoForm.addHiddenFields(hiddenFields);
      }
    });
  }

  if (typeof MktoForms2 !== "undefined" && MktoForms2 !== null) {
    MktoForms2.whenReady(function(mktoForm) {

      setTimeout(function (){
        $('.mktoForm').show();
      }, 1000);

      useReCAPTCHA(mktoForm, {
        size: "invisible",
        sitekey: "6LedangUAAAAAB-Ui5rF3BFXXmq8JNnAluCmVCJe",
        fieldName: "lastreCAPTCHAUserResponse",
        errorMessage: "Sorry, something went wrong."
      });
    });
  }

})(jQuery);

/**
 * @function    offsiteLinksTargeting
 * @description Make off-site links target _blank, unless an target attribute already exists. Does not affect header or footer (or anything outside of div.site__content).
 * @version     3.0.0   28 MAR 2022   Allow selector arg, provide (corrected) default.
 * @author      spencers
 */
function offsiteLinksTargeting(selectorArg){
  'use strict';

  // querySelectorAll selector cannot start with an ID b/c StOoPiD
  // var selector = '#content a';
  var selector = '.site-content a';
  if (typeof selectorArg == 'string') {
    var tmp = selectorArg.replace(/[^a-z0-9\.\_\- ]/gi,'');
    if (tmp != '') { selector = tmp; }
  }

  const footerExchLx = document.querySelectorAll('footer.site-footer a[href^="https://exchange.seismic.com"]');
  for (let h=0, hLen=footerExchLx.length; h<hLen; h++) {
    let rel = footerExchLx[h].getAttribute('rel');
    if (rel && rel.indexOf('noreferrer') >= 0) {
      footerExchLx[h].setAttribute('rel', rel.replace('noreferrer', '').trim() );
    }
    footerExchLx[h].setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
  }
  const pageLinks = document.querySelectorAll(selector);
  if (!pageLinks) { return; }
  const thisDomain = 'https://' + window.location.hostname + '/';
  /* for loop w/ length caching is significantly faster than a forEach loop */
  for (let i=0, len=pageLinks.length; i<len; i++) {
    let link = pageLinks[i];
    if (!link.hasAttribute('target')) {
      if ( !link.href.startsWith(thisDomain) && !link.href.startsWith('#') && !link.href.startsWith('/') && !link.href.startsWith('https://seismic.com/')  && !link.href.startsWith('javascript:')) {
          link.setAttribute('target', '_blank');
      }
    }
    if (link.href.startsWith('https://exchange.seismic.com')) {
      let rel = link.getAttribute('rel');
      if (rel && rel.indexOf('noreferrer') >= 0) {
        link.setAttribute('rel', rel.replace('noreferrer', '').trim() );
      }
      link.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    }
  }
}
document.addEventListener('DOMContentLoaded', offsiteLinksTargeting, false);



/**
 * @function blogHeaderImageSizer
 * Helper for blog-header-pattern. Basically the same as legacy sizer code that used to be site-wide.
 * Same function (with different selector) is also embedded in the Blog hub template.
 * Pending redesign will likely obviate this.
 * @version 22 APRIL 2022
 */
;(function($) {
  function blogHeaderImageSizer() {
      $('.blog-header-pattern img.wp-post-image').each(function(index) {
          var $This = $(this);
          $This.height($This.width());
          $(this).on('load', function() {
              var $This = $(this);
              $This.height($This.width());
          });
      });
  }
  $(document).ready(function() {
      blogHeaderImageSizer();
      $(window).smartresize(function() {
          blogHeaderImageSizer();
      });
  });
})(jQuery);


/**
 * Unstick footer when viewport is too short
 * Seismic 2022 Redesign
 */
;(function() {
    var sticky_footer = debounce(function() {
        var menu_height = 0;
        if ( document.getElementsByClassName('site-header__navigation-primary').length ) {
          menu_height = document.querySelector('.site-header__navigation-primary').clientHeight;
        }
        if ( document.getElementsByClassName('site-header__navigation-no-nav').length ) {
          menu_height = document.querySelector('.site-header__navigation-no-nav').clientHeight;
        }
        var site_footer = document.getElementById('site-footer');

        if ( ! site_footer ) {
            return;
        }

        var footer_height = site_footer.clientHeight;
        var viewport_height = window.outerHeight;
        var total_height = footer_height + menu_height + 100; // 100 for padding

        if (total_height >= viewport_height) {
            site_footer.classList.add("site-footer__unstick");
        } else {
            site_footer.classList.remove("site-footer__unstick");
        }
    }, 250);

    window.addEventListener('resize', sticky_footer);
    document.addEventListener('scroll', sticky_footer);
    document.addEventListener('DOMContentLoaded', sticky_footer);
})();


/**
 * @function    seismicFloatingLabels
 * @description Implements Material-like form labels that look like placeholders, then float above the field when focused. ALSO: auto-expanding textareas.
 * @example     Add CSS class `floating-labels-form` to any wrapper element containing the form fields to activate. Some baseline styles required: see _wpforms-defaults.scss
 */

 function seismicFloatingLabels() {
  var forms = document.querySelectorAll('.floating-labels-form');
  if (!forms) { return; }

  function textareaAutoResize() {
      var s = window.getComputedStyle(this),
          adj = parseFloat(s.getPropertyValue('padding-top')) + parseFloat(s.getPropertyValue('padding-bottom'));
      this.style.height = 'auto';
      this.style.height = (this.scrollHeight - adj) +'px';
  }

  forms.forEach(function(form) {
      var fields = form.querySelectorAll('input[type=text], input[type=email], input[type=tel], select');
      if (fields) {
          fields.forEach(function(field){
              var parent = field.parentNode;
              parent.classList.add('floating-label');
              if (field.tagName == 'SELECT') {
                  parent.classList.add('floating-select');
              }
              field.addEventListener('blur', function(){
                  this.value = this.value.trim();
                  if (this.value != '') {
                      parent.classList.add('not-null');
                  } else {
                      parent.classList.remove('not-null');
                  }
              }, false);
          });
      }

      var textareas = form.querySelectorAll('textarea');
      if (textareas) {
          textareas.forEach(function(textarea){
              textarea.addEventListener('input', textareaAutoResize, false);
          });
      }
  });
}
document.addEventListener('DOMContentLoaded', seismicFloatingLabels, false);


/**
 * Parallax scroll event listener.
 * Initially used on the magnitude landing page.
 *
 * Data Attributes:
 *      data-start="integer"    => only set for zero but can be modified to support custom values.
 *      data-hide="integer"     => In pixel values determine the when the element should become hidden.
 *      data-direction="to-top" => Reverses default direction of the parallax effect.
 *          Can also use the section-parallax__to-top class on the same element that you apply the parallax class to.
 */
function parallax_trigger() {
    const media_query_motion = window.matchMedia('(prefers-reduced-motion: reduce)')
    // const window_offset_top = window.scrollY
    const layers = document.querySelectorAll('.section-parallax')
    const window_height = window.outerHeight

    // https://since1979.dev/respecting-prefers-reduced-motion-with-javascript-and-react/
    if (media_query_motion && media_query_motion.matches) {
        layers.forEach(layer => (layer.style.transform = ''))
        return
    }

    if (
        // If we are zoomed in or out on 2x or 1x displays don't parallax and reset element
        Math.round(window.devicePixelRatio * 100) < 100 ||
        Math.round(window.devicePixelRatio * 100) > 200 ||
        991 >= window.innerWidth // No parallax on mobile
    ) {
        layers.forEach(layer => {
            layer.style = ''
        })

        return
    }

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1 // Trigger when 10% of the element is visible
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // If the element is intersecting with the viewport, apply parallax effect
                applyParallax(entry.target)
                observer.unobserve(entry.target) // Stop observing once the element is in the viewport
            }
        })
    }, observerOptions)

    layers.forEach(layer => {
        observer.observe(layer) // Start observing each layer
    })

    function applyParallax(layer) {
        const window_offset_top = window.scrollY
        const layer_offset_top = layer.offsetTop
        const layer_height = layer.clientHeight
        const layer_half_height = layer_height / 2

        let movement
        let difference
        let layer_bottom_margin = 36

        if (layer.dataset.start) {
            difference = parseFloat(layer.dataset.start)
        } else {
            difference = parseFloat(layer.dataset.speed)
        }

        if (0 === difference) {
            movement = window_offset_top * 1.3
        } else if (difference) {
            movement = (window_offset_top - (layer_offset_top - layer_half_height)) * difference
        } else {
            // console.log('here')
            movement = (window_offset_top - (layer_offset_top - layer_half_height)) * 0.18
        }

        // section-parallax__to-top or data-direction="to-top" animates the region up while you scroll down.
        // This is useful for when you have a parallax section near the footer of the site.
        const moves_up_by_class = layer.classList.contains('section-parallax__to-top')
        const moves_up_by_attribute = 'to-top' === layer.dataset.direction
        if (moves_up_by_class || moves_up_by_attribute) {
            movement = movement * -1
        }

        if (layer.dataset.hide) {
            const visibility = window_offset_top < parseInt(layer.dataset.hide) ? 'visible' : 'hidden'
            const pointer = window_offset_top < parseInt(layer.dataset.hide) ? 'auto' : 'none'
            layer.style.visibility = visibility
            layer.style.pointerEvents = pointer
        }

        const maxStart = parseFloat(layer.dataset.maxStart)
        if (maxStart !== undefined && movement <= -maxStart) {
            movement = -maxStart
        }

        const stop = parseFloat(layer.dataset.stop)
        if (stop !== undefined && movement >= stop) {
            movement = 0
        }

        if (layer_height > window_height) {
            layer.style.marginBottom = `${movement}px`
        }

        const translate3d = `translate3d(0, ${movement}px, 0)`
        layer.style.webkitTransform = translate3d
        layer.style.MozTransform = translate3d
        layer.style.msTransform = translate3d
        layer.style.OTransform = translate3d
        layer.style.transform = translate3d
    }
}

;(function() {
    const observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
                parallax_trigger()
            }
        }
    })

    observer.observe(document.getElementById('content'), { childList: true, subtree: true })

    window.addEventListener('resize', parallax_trigger)
    document.addEventListener('scroll', parallax_trigger)
    document.addEventListener('DOMContentLoaded', parallax_trigger)
})();

/**
 * Fade in background elements when they enter viewport.
 */
// ;(function() {
//     function inner_parallax() {
//         const sections = document.querySelectorAll('.inner-section-parallax')

//         if (!sections.length) return

//         const enters_view_port = new IntersectionObserver(
//             function (entries) {
//                 entries.forEach(entry => {
//                     const first_child = entry.target.firstChild
//                     const position_y =  entry.intersectionRect.y

//                     if (entry.isIntersecting === true && position_y !== 0) {
//                         first_child.classList.add('animate_up_fade_in')
//                     } else if (entry.isIntersecting === true && position_y === 0) {
//                         first_child.classList.add('animate_down_fade_in')
//                     } else {
//                         first_child.classList.remove('animate_up_fade_in')
//                         first_child.classList.remove('animate_down_fade_in')
//                     }
//                 })
//             },
//             { threshold: [0] }
//         )

//         sections.forEach(section => {
//             enters_view_port.observe(section)
//         });
//     }

//     document.addEventListener('DOMContentLoaded', inner_parallax)
// })();

/**
 * Toggle display of hidden element.
 *
 * Use the .action-show-element class on a button element that uses a jump link
 * that goes to another elmenent on the page that is hidden. This will toggle
 * the display of that element as the button is clicked.
 *
 * Initially used on the magnitude landing page.
 */;(function() {
    const translations = window.seismic_global_variables.translations;

    document.querySelectorAll('.action-show-element').forEach(button => {
        const container_to_reveal = button.getAttribute('href').substring(1);
        const container = document.getElementById(container_to_reveal);
        let container_height = container.offsetHeight;

        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', container_to_reveal);
        button.setAttribute('role', 'button');

        container.setAttribute('aria-hidden', 'true');
        container.setAttribute('role', 'region');
        container.setAttribute('tabindex', '-1');

        // container.style.transition = 'max-height 0.5s';
        // container.style.maxHeight = '0';
        container.style.display = 'none';
        container.style.overflow = 'hidden';

        button.addEventListener('click', function(event) {
            event.preventDefault();

            if ('true' === container.getAttribute('aria-hidden')) {
                container.setAttribute('aria-hidden', 'false');
                container.focus();
                // container.style.maxHeight = container_height + 'px';
                container.style.display = 'block';
                this.classList.add('cta-primary-large-minus');
                this.classList.remove('cta-primary-large-plus');
                this.querySelector('span').innerHTML = translations.see_less;
                button.setAttribute('aria-expanded', 'true');

                window.setTimeout(() => {
                    container.style.removeProperty('max-height');
                }, 500);
            } else {
                container.setAttribute('aria-hidden', 'true');
                // container.style.maxHeight = container.offsetHeight + 'px';
                // container.offsetHeight;
                // container.style.maxHeight = 0;
                container.style.display = 'none';
                this.classList.add('cta-primary-large-plus');
                this.classList.remove('cta-primary-large-minus');
                this.querySelector('span').innerHTML = translations.see_more;
                button.setAttribute('aria-expanded', 'false');

                // button.scrollIntoView({
                //     behavior: 'smooth',
                //     block: 'end',
                //     inline: 'nearest',
                // });
            }
        })
    });
})();

/**
 * Extended banner scripts for hiding banner and prevent appearance on reload.
 * @version   09 FEB 2023 Add tests for required DOM objects to prevent errors
 */
;(function() {
    const extended_banner_element = document.getElementById('extended_banner_animation_js');
    const page_banner = document.querySelector('.page-banner');

    /**
     * We have two banners on the page we should only have one visible to the
     * user. Once the expanded banner is done we will close it out and allow
     * focus on the normal banner if the user returns to the top of the page.
     */
    if (page_banner && !extended_banner_element) {
      //  Doesn't hurt to set this in this use case, and may as well be sure it's not hidden by accident somehow.
      (!page_banner.classList.contains('banner_no-banner')) ? page_banner.removeAttribute('aria-hidden') : page_banner.setAttribute('aria-hidden', true)
      return;
    }

    // Set only if we are in business:
    if (extended_banner_element) {
        extended_banner_element.setAttribute('aria-live', 'polite')
        page_banner.setAttribute('aria-hidden', true)
        page_banner.setAttribute('aria-live', 'polite') // Ensures UATs know when changes occur to the region (incl. hidden/visible status)

        let extended_banner_duration = extended_banner_element.getAttribute('data-duration')
        if (extended_banner_duration) {
            extended_banner_duration = parseInt(seismicUtilities.scrub(extended_banner_duration))
        }
        if (isNaN(extended_banner_duration) || extended_banner_duration == '') {
            extended_banner_duration = 12000
        } else if (extended_banner_duration === 0) {
            extended_banner_duration = 1
        }

        const extended_banner = debounce(event => {
            if ('a' == event.target.nodeName) {
                // If the user focuses/mouses over on the archor, reset the timer.
                return
            }

            extended_banner_element.classList.add('extended-banner__animate-away')
            extended_banner_element.setAttribute('aria-hidden', true)
            page_banner.setAttribute('aria-hidden', false)

            const hidden_elements = document.querySelectorAll('.extended_banner_exits')

            if (hidden_elements) {
                hidden_elements.forEach(element => element.classList.remove('extended_banner_exits'))
            }

            // Pantheon needs wp- on the cookie.
            const extended_banner_name = `wp-extended_banner_${extended_banner_element.dataset.extendedBannerName}`
            setCookieSeismic(extended_banner_name, true, 31)
        }, extended_banner_duration)

        document.addEventListener('DOMContentLoaded', extended_banner)

        // If the window resizes in a way that reveals the banner, reset the timer.
        window.addEventListener('resize', extended_banner)

        // If a user focus on the button, reset the timer.
        extended_banner_element.querySelector('a').addEventListener('focus', extended_banner)

        // If the mouses over the extended banner they might be interested or
        // reading it, reset the timer.
        extended_banner_element.addEventListener('mouseover', extended_banner)
    }


})();

function logFacetReset(dataName) {
  if (typeof sega4 != 'object' || typeof sega4.facet.logReset != 'function' || typeof dataName != 'string') { return; }
  sega4.facet.logReset( seismicUtilities.scrub(dataName) );
}

/**
 * Add accessibility to jQuery modal instances and modified close button.
 *
 * @link https://github.com/kylefox/jquery-modal
 * @link https://www.w3.org/WAI/ARIA/apg/patterns/dialogmodal/
 * @link https://hidde.blog/using-javascript-to-trap-focus-in-an-element/
 * @link https://uxdesign.cc/how-to-trap-focus-inside-modal-to-make-it-ada-compliant-6a50f9a70700
 */
;(function ($) {
    $('document').ready(function () {
        function set_close_button(modal_instance) {
            // .close-smodal__wrapper div is critial for close button position.
            const modal_wrapper = document.createElement('div')
            const modal_close_button = modal_instance.querySelectorAll('.close-smodal')
            const new_close_button = modal_close_button[0].cloneNode(true)
            const has_close_button = modal_instance.querySelectorAll('.close-smodal__wrapper')
            modal_wrapper.classList.add('close-smodal__wrapper')
            modal_close_button.forEach(button => button.remove())

            if (has_close_button.length) {
                // went this route to get past the double click modal issue where
                // you would end up with multiple close buttons.
                has_close_button.forEach(button => button.remove())
            }

            modal_wrapper.appendChild(new_close_button)
            modal_instance.append(modal_wrapper)
        }

        function modal_state_tracking() {
            let previousElement = null
            $('.smodal').on($.smodal.OPEN, function (event, modal) {
                set_close_button(this)

                // add all the elements inside modal which you want to make focusable
                const modal_instance = modal.elm[0]
                const focusableElements =
                    '.smodal, a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
                modal_instance.setAttribute('tabindex', '-1')
                previousElement = modal.$anchor[0] || document.body

                const firstFocusableElement = modal_instance // get first element to be focused inside modal
                const focusableContent = modal_instance.querySelectorAll(focusableElements)
                const lastFocusableElement = focusableContent[focusableContent.length - 1] // get last element to be focused inside modal

                document.addEventListener('keydown', function (event) {
                    let isTabPressed = event.key === 'Tab' || event.code === 'Tab'

                    if (!isTabPressed) {
                        return
                    }

                    if (event.shiftKey) {
                        // if shift key pressed for shift + tab combination
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus() // add focus for the last focusable element
                            event.preventDefault()
                        }
                    } else {
                        // if tab key is pressed
                        if (document.activeElement === lastFocusableElement) {
                            // if focused has reached to last focusable element then focus first focusable element after pressing tab
                            firstFocusableElement.focus() // add focus for the first focusable element
                            event.preventDefault()
                        }
                    }
                })

                firstFocusableElement.focus()

                // console.group('Taking focus away from trigger')
                // console.log(previousElement)
                // console.log(document.activeElement)
                // console.groupEnd()
            })

            $('.smodal').on($.smodal.CLOSE, function (event, modal) {
                // console.group('Restoring focus to previously-active element')
                // console.log(previousElement)
                // console.groupEnd()

                const modal_instance = modal.elm[0]
                modal_instance.setAttribute('tabindex', '0')

                if (previousElement) {
                    if (previousElement.classList.contains('linkify-link')) {
                        previousElement = previousElement.closest('.linkify-me')
                    }

                    setTimeout(() => {
                        // Give a pause or modal reopens.
                        previousElement.focus()
                        previousElement = null
                    }, 500)
                }
            })
        }
        modal_state_tracking()

        document.addEventListener('facetwp-loaded', function () {
            modal_state_tracking()
        })

        document.querySelectorAll('.smodal').forEach(modal => {
            modal.setAttribute('role', 'dialog')
            modal.setAttribute('aria-modal', 'true')
        })
    })
})(jQuery)

/**
 * Fade in background elements when they enter viewport.
 */
;(function () {
    function fade_in_when_in_view() {
        const backgrounds = document.querySelectorAll('[class*=section-bg-midline-')

        if (!backgrounds.length) return

        const observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].isIntersecting === true) {
                    entries.forEach(entry => {
                        // if (entry.target.classList.contains('section-bg-midline__fade-in')) return

                        setTimeout(() => {
                            entry.target.classList.add('section-bg-midline__fade-in')
                        }, 500)
                    })
                }
            },
            { threshold: [0.2] }
        )

        backgrounds.forEach(background => {
            observer.observe(background)
        })
    }

    document.addEventListener('DOMContentLoaded', fade_in_when_in_view)
})()

/**
 * This function takes values from when the marketo forms are submitted and
 * stores specific values in session storage.
 * 
 * @link https://developers.marketo.com/javascript-api/forms/api-reference/
 */
function store_marketo_values_session_storage() {
    if (typeof MktoForms2 !== 'undefined' && MktoForms2 !== null) {
        MktoForms2.whenReady(function(form) {
            form.onSuccess((vals, thanksURL) => {
                if (vals.Email) {
                    sessionStorage.setItem(
                        'seismic_marketo_submission',
                        JSON.stringify({ email: vals.Email })
                    )
                }
            })
        })
    }
}
store_marketo_values_session_storage()